'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'
import type { ComponentProps, ReactNode } from 'react'
import { cn } from '@/src/utils/styles'

const Tabs = TabsPrimitive.Root

const TabsList = ({
  className,
  ref,
  ...props
}: ComponentProps<typeof TabsPrimitive.List>) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn('inline-flex flex-col', className)}
    {...props}
  />
)
TabsList.displayName = TabsPrimitive.List.displayName

interface TabsTriggerProps
  extends ComponentProps<typeof TabsPrimitive.Trigger> {
  icon?: ReactNode
  title?: string
  rightElement?: ReactNode
}

const TabsTrigger = ({
  className,
  icon,
  title,
  rightElement,
  ref,
  ...props
}: TabsTriggerProps) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'text-secondary transition-colors hover:bg-surface1 data-[state=active]:bg-surface1 data-[state=active]:text-primary font-semibold',
      className,
    )}
    {...props}
  >
    {icon}
    <span className='font-semibold'>{title}</span>
    {rightElement}
  </TabsPrimitive.Trigger>
)
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const SectionTabsTrigger = ({
  className,
  icon,
  title,
  rightElement,
  ref,
  ...props
}: TabsTriggerProps) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'p-3 first:-ml-3 text-primary text-xl font-semibold transition-colors hover:opacity-80 rounded-lg focus-outer data-[state=active]:opacity-100 data-[state=inactive]:text-tertiary',
      className,
    )}
    {...props}
  >
    {icon}
    <span>{title}</span>
    {rightElement}
  </TabsPrimitive.Trigger>
)
SectionTabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = ({
  className,
  ref,
  ...props
}: ComponentProps<typeof TabsPrimitive.Content>) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn('w-full', className)}
    {...props}
  />
)
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsContent, TabsList, SectionTabsTrigger }
